<template>
  <div class="continer_box">
    <div class="pay-success">
      <!-- 菜单栏（内嵌App时隐藏） -->
      <app-header :title="title" :transparent="true" back-type="back-app" />
      <!-- 购买成功 -->
      <div class="pay-status">
        <span class="img-success"></span>
        <!-- 通用购买提示 -->
        <div class="course-text">
          <div class="course-success">报名成功</div>
        </div>
      </div>
      <!-- 用户 -->
      <PayUser :user="payStatus" :goodsId="goodsId" :success="true" />
    </div>
  </div>
</template>

<script>
// 商品订单的成功页面
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import PayUser from '../component/pay-user'
import { appUser } from '@/utils'

export default {
  name: 'camp-success',
  components: { PayUser },
  mixins: [Body],
  data() {
    return {
      title: '训练营'
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'payStatus' // 支付状态
    ]),
    goodsId() {
      return this.$route.query.id
    }
  },
  activated() {
    const { goodsId } = this
    console.log('payment/order/getPayStatus', goodsId)
    this.$store.commit('payment/order/getPayStatus', { goodsId })
    console.log('训练营--', this.payStatus)
    try {
      // 调用IOS的方法 允许左滑手势
      const bridge = window.WebViewJavascriptBridge
      if (bridge) {
        bridge.send('allowsBackForwardGestures', 'disable')
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    isNative() {
      return appUser.isNative
    }
  }
}
</script>

<style lang="scss" scoped>
.continer_box {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f7f9fb;
}
.pay-success {
  position: relative;
  width: 100%;
  height: 4.24rem;
  background: url("../../../images/payment/success_BG_ellipse_left.png")
      no-repeat,
    url("../../../images/payment/success_BG_ellipse_right.png") no-repeat,
    url("../../../images/payment/success_BG.png") no-repeat;
  background-color: #f7f9fb;
  background-size: 52px 79px, 65px 100px, 100% 100%;
  background-position-x: left, right, center;
  background-position-y: 22%, 7%, top;
  // 支付状态
  .pay-status {
    position: absolute;
    top:0.8rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
    font-weight: bold;
    padding:0.2rem 0 0;
    color: white;
    text-align: center;
    .img-success {
      display: inline-block;
      width: 48px;
      height: 48px;
      border: 1px solid rgba(255, 255, 255, 1);
      border-radius: 50%;
      margin-bottom: 10px;
      background: url("../../../images/payment/icon_choose_large_def.png")
        no-repeat;
      background-size: 20px;
      background-position: center;
    }
    // 课程引导
    .course-text {
      .course-success {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        opacity: 1;
      }
      // 进入书桌
      .desk {
        margin-top: 10px;
        height: 17px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 17px;
      }
    }
  }
}
</style>
